import { render } from "./GamesFilterComponent.vue?vue&type=template&id=604eb186&scoped=true"
import script from "./GamesFilterComponent.vue?vue&type=script&lang=js"
export * from "./GamesFilterComponent.vue?vue&type=script&lang=js"

import "./GamesFilterComponent.vue?vue&type=style&index=0&id=604eb186&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604eb186"]])

export default __exports__